module.exports = "/static/js/c2d81a800622e915cf5cbc088524cd55.png";